import { cloneElement, ReactElement, useState } from "react";

import { Flex, FlexProps } from "@chakra-ui/react";

import { CheckIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

type DropDownListItemProps = {
  isSelected: boolean;
  label: string;
  icon?: ReactElement<any>;
  dataTestId?: string;
  listItemStyles?: Omit<FlexProps, "onInput">;
  onClickItem: () => void;
};

export function DropDownListItem({
  isSelected,
  label,
  icon,
  dataTestId,
  listItemStyles,
  onClickItem,
}: DropDownListItemProps) {
  const [isClicked, setIsClicked] = useState(false);
  const onClickCard = () => {
    setIsClicked(true);
    onClickItem();
    setTimeout(() => {
      setIsClicked(false);
    }, 200);
  };

  return (
    <Flex
      width="237px"
      minHeight="56px"
      bgColor={isClicked ? "grey.200" : "white"}
      color="black"
      alignItems="center"
      paddingX="s200"
      justify="space-between"
      onClick={onClickCard}
      as="li"
      data-testid={dataTestId}
      {...listItemStyles}
    >
      <Flex flex="1" align="center" overflow="hidden" whiteSpace="nowrap" gap="s100">
        {icon && cloneElement(icon, { boxSize: "24px", flexShrink: 0 })}
        <BodyM
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          color={listItemStyles?.color}
        >
          {label}
        </BodyM>
      </Flex>
      {isSelected && (
        <Flex width="24px" justify="center">
          <CheckIcon color="pink.500" />
        </Flex>
      )}
    </Flex>
  );
}
